import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
var axios = require("axios");

function isApiSuccessStatus(status) {
  return String(status || "").toLowerCase() === "success";
}

function isBackgroundProcessingHttpError(error) {
  const status = error?.response?.status;
  if (status === 524 || status === 504 || status === 408) return true;
  if (error?.code === "ECONNABORTED") return true;
  const msg = String(error?.message || "").toLowerCase();
  return msg.includes("network error") || msg.includes("timeout");
}

function showBackgroundProcessingToast(payload, text) {
  if (!payload?.context?.$toast) return;
  payload.context.$toast({
    component: ToastificationContent,
    props: {
      title: "Processing",
      icon: "ClockIcon",
      text:
        text ||
        payload.backgroundProcessingMessage ||
        payload.message ||
        "Your request is being processed in the background.",
      variant: "info",
    },
  });
}

export default {
  // namespaced: true,
  state: {
    cmbDepartment: null,
    cmbClass: null,
    cmbSec: null,
    cmbSubjects: null,
    cmbExamType: null,
    cmbFeeType: null,
    user: null,
    data: null,
    campusID: 1,
  },

  getters: {
    cmbDepartment: (state) => state.cmbDepartment,
    cmbClass: (state) => state.cmbClass,
    cmbSec: (state) => state.cmbSec,
    cmbSubjects: (state) => state.cmbSubjects,
    cmbExamType: (state) => state.cmbExamType,
    cmbFeeType: (state) => state.cmbFeeType,
    user: (state) => state.user,
    data: (state) => state.data,
    campusID: (state) => state.campusID,
  },
  mutations: {
    updateData(state, payload) {
      state.data = payload;
    },
    cmbDepartment(state, val) {
      state.cmbDepartment = val;
    },
    Logout(state, val) {
      state.user = null;
    },
  },
  actions: {
    //async
    async getDepartment(state) {
      var config = {
        method: "get",
        url: "https://myskool.fastech.pk/api/departments",
        headers: {
          Authorization:
            "bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJhYmMiLCJqdGkiOiI4NmQyMDQ3NC0xZjg5LTQ5NWItYjc2MC04NzY4NjI1MWJkYTEiLCJleHAiOjE2NzA0MjAyNzksImlzcyI6Im15c2tvb2wuYXBwIiwiYXVkIjoibXlza29vbC5hcHAifQ.jPCDB2X_5FAc9MrT-2oaFrcfM6-fwJ64isfQ_PCxzYM",
        },
      };

      var data = await axios(config);
      state.commit("cmbDepartment", data.data);
    },

    async get(state, val) {
      var config = {
        method: "get",
        url: val.url,
        headers: {
          Authorization: "bearer " + val.token,
        },
      };

      try {
        var data = await axios(config);
        if (data.data.status === "success" && val.message) {
          val.context.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "CheckIcon",
              text: val.message,
              variant: "success",
            },
          });
          return true;
        } else if (data !== undefined && (val.dashboard || val.returnData))
          return data.data;
        else if (data !== undefined) return data.data.data;
        else return [];
      } catch (error) {
        if (val.returnData) return false;
        return [];
      }
    },

    async getString(state, val) {
      var config = {
        method: "get",
        url: val.url,
        headers: {
          Authorization: "bearer " + val.token,
        },
      };

      try {
        var data = await axios(config);
        if (data !== undefined) return data.data;
        else return [];
      } catch (error) {
        return [];
      }
    },

    async post(state, payload) {
      try {
        var config = {
          method: "post",
          url: payload.url,
          headers: {
            Authorization: "bearer " + payload.token,
          },
          data: payload.body,
        };

        var data = await axios(config);
        if (data.data.status === "success" && payload.validation) {
          payload.context.$toast({
            component: ToastificationContent,
            props: {
              title: "Success",
              icon: "InfoIcon",
              text: data.data.message,
              variant: "success",
            },
          });
          return data.data.data;
        } else if (data.data.status === "error" && payload.validation) {
          payload.context.$toast({
            component: ToastificationContent,
            props: {
              title: "Error",
              icon: "InfoIcon",
              text: data.data.message,
              variant: "danger",
            },
          });
          return data.data.data;
        }
        if (payload.isBulkUpload) {
          return data.data;
        }
        if (data.data.status === "success" && payload.upload) {
          return true;
        } else if (data.data.status === "error" && payload.upload) {
          payload.context.$toast({
            component: ToastificationContent,
            props: {
              title: "Error",
              icon: "InfoIcon",
              text: data.data.message,
              variant: "danger",
            },
          });
          return data.data.data;
        } else if (data.data.status === "error" && payload.isTimetableConfig) {
          payload.context.$toast({
            component: ToastificationContent,
            props: {
              title: "Error",
              icon: "InfoIcon",
              text: data.data.message,
              variant: "danger",
            },
          });
          return data.data.data;
        }
        if (
          (data.data.status === "success" && payload.attendance) ||
          payload.whatsapp
        ) {
          return data.data.data;
        }
        if (data.data.status === "success" && payload.subjects) {
          return data.data.data;
        }
        if (data.data.status === "success" && payload.homework) {
          return data.data.data;
        }
        if (data.data.data === "No data found." && payload.homework) {
          return false;
        }

        if (data.data.status === "success" && payload.savingMarks) {
          payload.context.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "CheckIcon",
              text: payload.message,
              variant: "success",
            },
          });
          return data.data.data;
        }
        if (data.data.status === "success" && payload.returnData) {
          payload.context.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "CheckIcon",
              text: payload.message,
              variant: "success",
            },
          });
          return data.data.data;
        }
        if (data.data.status === "success" && payload.showAndReturn) {
          payload.context.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "CheckIcon",
              text: payload.message,
              variant: "success",
            },
          });
          return data.data;
        }
        if (isApiSuccessStatus(data.data.status) && payload.allResponse) {
          return data.data;
        }
        if (data.data.status === "success" && payload.attMarks) {
          payload.context.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "CheckIcon",
              text: payload.message,
              variant: "success",
            },
          });
          return data.data;
        }
        if (data.data.status === "success" && payload.feeReceive) {
          payload.context.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "CheckIcon",
              text: payload.message,
              variant: "success",
            },
          });
          return data.data.slipNo;
        }
        if (
          payload.importing &&
          data.data.status === "success" &&
          payload.lastChunk
        ) {
          payload.context.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "CheckIcon",
              text: payload.message,
              variant: "success",
            },
          });
          return true;
        }
        if (payload.importing && data.data.status === "success") {
          return true;
        }
        if (payload.registration && data.data.status === "success") {
          return true;
        }
        if (data.data.status === "success") {
          payload.context.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "CheckIcon",
              text: payload.message,
              variant: "success",
            },
          });
          return true;
        } else if (payload.savingStudent && data.data.data === "exist") {
          var timeout = 10000;
          payload.context.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "Error",
                icon: "InfoIcon",
                text: "This GR number is already registerd!",
                variant: "danger",
              },
            },
            {
              timeout,
            }
          );
          return false;
        } else if (data.data.status === "error" && payload.showError) {
          let errorText = data.data.data;
          if (
            payload.errorFirstSentence &&
            typeof errorText === "string" &&
            errorText.trim()
          ) {
            const first = errorText.trim().split(/\.\s+/)[0].trim();
            errorText =
              first && !/[.!?]$/.test(first) ? `${first}.` : first || errorText;
          }
          payload.context.$toast({
            component: ToastificationContent,
            props: {
              title: "Error",
              icon: "InfoIcon",
              text: errorText,
              variant: "danger",
            },
          });
          return false;
        } else {
          var timeout = 10000;
          payload.context.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "Error",
                icon: "InfoIcon",
                text: "Request failed.",
                variant: "danger",
              },
            },
            {
              timeout,
            }
          );
          return false;
        }
      } catch (error) {
        var timeout = 10000;
        if (payload.ignoreTimeout && isBackgroundProcessingHttpError(error)) {
          if (payload.allResponse || payload.returnFullResponse) {
            return {
              status: "success",
              backgroundProcessing: true,
            };
          }
          if (payload.backgroundProcessingMessage) {
            showBackgroundProcessingToast(payload);
          }
          return true;
        }
        if (
          (payload.savingMarks || payload.attMarks) &&
          error.response.status == 500
        ) {
          payload.context.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "Error",
                icon: "InfoIcon",
                text: "Grading Policy is not defined correctly.",
                variant: "danger",
              },
            },
            {
              timeout,
            }
          );
          return false;
        } else {
          payload.context.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "Error",
                icon: "InfoIcon",
                text: error.message,
                variant: "danger",
              },
            },
            {
              timeout,
            }
          );
          return false;
        }
      }
    },
    async postPass(state, payload) {
      try {
        var config = {
          method: "post",
          url: payload.url,
          headers: {
            Authorization: "bearer " + payload.token,
          },
          data: payload.body,
        };
        var data = await axios(config);

        if (data.data.status === "success") {
          payload.context.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "CheckIcon",
              text: payload.message,
              variant: "success",
            },
          });
          return true;
        } else return false;
      } catch (error) {
        return false;
      }
    },

    async postObj(state, payload) {
      try {
        var config = {
          timeout: 300000,
          method: "post",
          url: payload.url,
          headers: {
            Authorization: "bearer " + payload.token,
          },
          data: payload.body,
        };

        var data = await axios(config);
        if (
          isApiSuccessStatus(data.data.status) &&
          payload.returnFullResponse
        ) {
          return data.data;
        }
        if (
          (isApiSuccessStatus(data.data.status) && payload.attendance) ||
          payload.whatsapp
        ) {
          return data.data.data;
        }
        if (isApiSuccessStatus(data.data.status)) {
          if (payload.message != null) {
            payload.context.$toast({
              component: ToastificationContent,
              props: {
                title: "Notification",
                icon: "CheckIcon",
                text: payload.message,
                variant: "success",
              },
            });
          }

          return data.data.data;
        } else if (data.data.status === "error" && payload.showError) {
          payload.context.$toast({
            component: ToastificationContent,
            props: {
              title: "Error",
              icon: "InfoIcon",
              text: data.data.data,
              variant: "danger",
            },
          });
          return false;
        } else if (payload.savingStudent && data.data.data === "exist") {
          var timeout = 10000;
          payload.context.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "Error",
                icon: "InfoIcon",
                text: "This GR number is already registerd!",
                variant: "danger",
              },
            },
            {
              timeout,
            }
          );
          return data.data.data;
        } else {
          var timeout = 10000;
          payload.context.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "Error",
                icon: "InfoIcon",
                text: "Request failed.",
                variant: "danger",
              },
            },
            {
              timeout,
            }
          );
          return false;
        }
      } catch (error) {
        if (payload.ignoreTimeout && isBackgroundProcessingHttpError(error)) {
          if (payload.returnFullResponse) {
            return {
              status: "success",
              backgroundProcessing: true,
            };
          }
          if (payload.backgroundProcessingMessage) {
            showBackgroundProcessingToast(payload);
          }
          return true;
        } else if (payload.ignoreMessage) {
          return false;
        } else {
          var timeout = 10000;
          payload.context.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "Error",
                icon: "InfoIcon",
                text: error.message,
                variant: "danger",
              },
            },
            {
              timeout,
            }
          );
          return false;
        }
      }
    },

    async put(state, payload) {
      // console.log(payload);
      var config = {
        method: "put",
        url: payload.url,
        headers: {
          Authorization: "bearer " + payload.token,
        },
        data: payload.body,
      };

      try {
        var data = await axios(config);
        if (payload.importing && data.data.data === "updated") {
          return true;
        } else if (
          data.data.data === "updated" ||
          data.data.data == "done" ||
          data.data.status === "success"
        ) {
          if (payload.message) {
            payload.context.$toast({
              component: ToastificationContent,
              props: {
                title: "Notification",
                icon: "CheckIcon",
                text: payload.message,
                variant: "success",
              },
            });
          }
          return data.data.data !== undefined ? data.data.data : true;
        } else if (payload.savingStudent && data.data.data === "exist") {
          var timeout = 10000;
          payload.context.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "Error",
                icon: "InfoIcon",
                text: "This GR number is already registerd!",
                variant: "danger",
              },
            },
            {
              timeout,
            }
          );
          return false;
        } else if (data.data.status === "error" && payload.showError) {
          payload.context.$toast({
            component: ToastificationContent,
            props: {
              title: "Error",
              icon: "InfoIcon",
              text: data.data.data || data.data.message || "Request failed.",
              variant: "danger",
            },
          });
          return false;
        } else {
          var timeout = 10000;
          payload.context.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "Error",
                icon: "InfoIcon",
                text: "Request failed.",
                variant: "danger",
              },
            },
            {
              timeout,
            }
          );
          return false;
        }
      } catch (ex) {
        var timeout = 10000;
        payload.context.$toast(
          {
            component: ToastificationContent,
            props: {
              title: "Error",
              icon: "InfoIcon",
              text: ex.message,
              variant: "danger",
            },
          },
          {
            timeout,
          }
        );
        return false;
      }
    },

    async delete(state, payload) {
      var config = {
        method: "delete",
        url: payload.url,
        headers: {
          Authorization: "bearer " + payload.token,
        },
      };

      try {
        var data = await axios(config);
        if (data.data.status === "success" && payload.grading) {
          return true;
        } else if (data.data.status === "success") {
          payload.context.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "CheckIcon",
              text: payload.message,
              variant: "success",
            },
          });
          return true;
        } else if (data.data.status === "error" && payload.showError) {
          payload.context.$toast({
            component: ToastificationContent,
            props: {
              title: "Error",
              icon: "InfoIcon",
              text:
                data.data.data || data.data.message || "Unable to delete data.",
              variant: "danger",
            },
          });
          return false;
        } else {
          var timeout = 10000;
          payload.context.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "Error",
                icon: "InfoIcon",
                text: "Unable to delete data.",
                variant: "danger",
              },
            },
            {
              timeout,
            }
          );
          return false;
        }
      } catch (error) {
        var timeout = 10000;
        payload.context.$toast(
          {
            component: ToastificationContent,
            props: {
              title: "Error",
              icon: "InfoIcon",
              text: error.message,
              variant: "danger",
            },
          },
          {
            timeout,
          }
        );
        console.error(error);
        return false;
      }
    },
  },
};
